/**
 * [AB#437] Evento de janela para avisar o shell que a assinatura do tenant
 * mudou.
 *
 * Existe por causa de um caso específico: ao contratar um plano no meio do
 * trial, o backend flipa o tenant de `TRIAL` para `ATIVO`. O `TrialBanner` vive
 * no shell, fora da árvore da tela de assinatura, e só refaz o `GET /auth/me`
 * em `visibilitychange` ou no heartbeat de 60 s. Sem este sinal, quem
 * ACABOU DE PAGAR continuaria vendo "seu período de avaliação termina em X
 * dias" por até um minuto — exatamente no momento em que a mensagem é mais
 * errada.
 *
 * Um evento de janela (e não um store) porque a relação é de notificação
 * pontual entre irmãos distantes, e o `TrialBanner` já é dono do seu próprio
 * estado a partir do `/auth/me`. Quem escuta continua tratando o backend como
 * fonte da verdade: o evento só antecipa o refetch, não carrega dado.
 */
export const EVENTO_ASSINATURA_ALTERADA = 'vinya:assinatura-alterada';

/** Dispara o sinal. Seguro em SSR/teste — no-op se não houver `window`. */
export function notificarAssinaturaAlterada(): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new Event(EVENTO_ASSINATURA_ALTERADA));
}
